<template>
  <div
    class="qq-web"
    v-if="QQState"
    ref="qqServe"
    :style="{ top: top + 'px' }"
    @mousedown="mousedown($event)"
    @mousemove="mousemove($event)"
    @mouseup="mouseup($event)"
  >
    <span class="iconfont client" @click="closeQQ">&#xe6f2;</span>
    <!-- <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=695396498&site=qq&menu=yes"> -->
    <a
      target="_blank"
      href="http://wpa.qq.com/msgrd?v=3&uin=695396498&site=qq&menu=yes"
    >
      <img border="0" src="/assets/pc/images/index/client.png" />
    </a>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "QQserve",
  data() {
    return {
      top: "300",
      flag: false,
      qq: {}
    };
  },
  computed: {
    ...mapState(["QQState"])
  },
  methods: {
    ...mapActions(["CHANGE_QQ_SERVE"]),
    closeQQ() {
      this.CHANGE_QQ_SERVE();
    },
    mousedown() {
      this.flag = true;
    },
    mousemove() {
      let top = event.clientY - this.qq.offsetHeight / 2; // 记录当前鼠标的y坐标
      if (top < 80) {
        top = 80;
      } else if (top > 400) {
        top = 400;
      }
      this.top = top;
    },
    mouseup() {
      this.flag = false;
    }
  },
  mounted() {
    this.qq = document.querySelector(".qq-web");
  }
};
</script>

<style lang="stylus">
.qq-web
  position fixed
  // top 50%
  left 1%
  z-index 1000
  img
    width 60px
  .client
    color #777
    position absolute
    top -35%
    left 60%
    transform translateX(-15px)
    cursor pointer
</style>
